export const faqs = [
  {
    question: '韩漫网上的漫画都是免费的吗？',
    answer: '是的！韩漫网上的所有韩国漫画都是完全免费的。我们致力于为广大漫画爱好者提供优质的免费韩漫在线阅读服务。您无需注册或付费即可畅享所有漫画内容。',
  },
  {
    question: '如何找到我想看的韩国漫画？',
    answer: '您可以通过多种方式找到心仪的韩漫：使用首页的分类导航浏览不同类别的漫画；通过搜索功能（即将上线）直接搜索漫画名称或作者；查看"热门推荐"和"最新更新"板块发现热门作品。',
  },
  {
    question: '漫画的更新频率是怎样的？',
    answer: '不同漫画的更新频率有所不同。热门连载漫画通常每周更新一次，部分作品可能每两周更新一次。您可以在漫画详情页看到最新的更新时间，也可以在首页"最新更新"板块查看最近更新的漫画。',
  },
  {
    question: '网站上的漫画有中文翻译吗？',
    answer: '所有漫画均提供简体中文翻译版本，由专业翻译团队精心翻译，确保阅读体验流畅自然。我们致力于为华语读者提供最优质的韩漫阅读体验。',
  },
  {
    question: '我可以在手机上阅读韩漫吗？',
    answer: '当然可以！韩漫网采用响应式设计，完美适配手机、平板和电脑等各种设备。无论您在哪里，都可以方便地打开浏览器访问我们的网址，享受流畅的韩漫在线阅读体验。',
  },
  {
    question: '如果遇到网站加载缓慢或无法访问怎么办？',
    answer: '请先检查您的网络连接是否正常。如果网络没有问题，可能是网站正在维护更新中，请稍后再试。如果问题持续存在，欢迎通过"关于我们"页面的联系方式与我们取得联系，我们会尽快处理。',
  },
  {
    question: '如何获取新漫画上线的通知？',
    answer: '您可以收藏我们的韩漫网址（加入浏览器书签），随时访问查看最新内容。我们也建议您关注首页的"最新更新"板块，那里会第一时间展示所有最新上线的漫画章节。',
  },
];